const __request = require(`../__request/__request_contentType_json`);

// 国内退款备注
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/manage/reimburseRemark',
    data:data
  }

  return __request(pParameter)
}

